import * as React from 'react';
import { useCallback, useState } from 'react';
import { css } from '@emotion/core';
import { useMsgText } from '../../../localization/hooks';
import Toggle from '../../../forms/Toggle';
import { useAppState } from '../../../core/redux/hooks';
import { setRemindersOnAction } from './setRemindersOnAction';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useProjIds } from '../../../navigation/hooks';
import { Str } from '../../../localization/translationKeys';
import Msg from '../../../localization/Msg';
import ModalHeader from '../../../layout/modal/ModalHeader';
import LocalDiv from '../../../localization/LocalDiv';
import Modal from '../../../layout/modal/Modal';
import { FLEX_COLUMN } from '../../../layout/flexBox';
import { COLORS } from '../../../globalStyle/colors';
import LocalBtn from '../../../localization/LocalBtn';
import { btnStyle } from '../../../forms/styles/button';


const styles = {
  modal:          [
    FLEX_COLUMN,
    css`
      min-height: 0;
      height: auto;
    `,
  ],
  root:           [
    FLEX_COLUMN,
    css`
      padding: 15px;

    `,
  ],
  reminderTxt:    css`
    display: block;
    margin-left: 28px;
    margin-right: 28px;
    margin-bottom: 14px;
    color: ${COLORS.DARK_GREY};
  `,
  reminderToggle: css`
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 28px;
  `,
  saveBtn:        [
    btnStyle.primary(COLORS.BLUE),
    css`
      align-self: flex-end;
      min-width: 135px;
    `,
  ],
};


type Props = {
  className?: string;
};


/**
 * DevPlanRemindersModal: a modal component that renders the dev plan reminders on/off toggle
 */
const DevPlanRemindersModal: React.FC<Props> = props => {
  const history  = useHistory();
  const dispatch = useDispatch();

  const projIds = useProjIds();

  const title = useMsgText(Str.EmailReminders);

  const remindersOn           = useAppState(state => !!state.devPlan?.emailRemindersOn);
  const [dirtyOn, setDirtyOn] = useState<boolean>(remindersOn);

  const dismiss = useCallback(() => history.goBack(), [history]);

  const dispatchNewValue = useCallback(
    (newValue) => dispatch(setRemindersOnAction(projIds.projId, projIds.participantId, newValue)),
    [projIds.participantId, projIds.projId, dispatch],
  );

  const setRemindersOn = useCallback(
    () => {
      dispatchNewValue(dirtyOn);
      dismiss();
    },
    [dirtyOn, dispatchNewValue, dismiss],
  );

  return (
    <Modal onDismiss={dismiss} dismissable={true} css={styles.modal} className={props.className}>
      <ModalHeader title={title} onDismiss={dismiss} />
      <LocalDiv css={styles.root}>
        <Msg str={Str.DevPlanReminders} css={styles.reminderTxt} />

        <Toggle
          value={dirtyOn}
          onChange={setDirtyOn}
          labelTranslation={Str.EmailReminders}
          css={styles.reminderToggle}
        />

        <LocalBtn
          str={Str.Done}
          onClick={setRemindersOn}
          disabled={dirtyOn === remindersOn}
          css={styles.saveBtn}
        />
      </LocalDiv>
    </Modal>
  );
};

export default DevPlanRemindersModal;
